import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../helper/apiCall";
import ENDPOINTS from "../../constants/endpoints";

const initialState = {
    loading: false,
    groups: [],
    selectedGroup: null,
    error: null
};

export const getGroups = createAsyncThunk(
    "getGroups",
    async (branchId, thunkAPI) => {
        try {       
            const response = await client.get(`${ENDPOINTS.GROUPS.GET_LIST}?branchId=${branchId}`, {
                token: thunkAPI.getState().auth.token
            });
            // API pagination formatında döndüğü için items array'ini alıyoruz
            return response.data.items || response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const deleteGroup = createAsyncThunk(
    "deleteGroup",
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.GROUPS.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const addGroup = createAsyncThunk(
    "addGroup",
    async (body, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.GROUPS.CREATE, body, {
                token: thunkAPI.getState().auth.token
            });
            
            // Response'dan gelen id ile request body'yi birleştir
            const result = {
                id: response.data.id,
                name: body.name,
                branchId: body.branchId
            };
            return result;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const updateGroup = createAsyncThunk(
    "updateGroup",
    async (body, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.GROUPS.UPDATE, body, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const getGroupById = createAsyncThunk(
    "getGroupById",
    async (id, thunkAPI) => {
        try {
            const response = await client.get(ENDPOINTS.GROUPS.GET_BY_ID.replace(':id', id), {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

const groupsSlice = createSlice({
    name: "groups",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSelectedGroup: (state) => {
            state.selectedGroup = null;
        },
        setSelectedGroup: (state, action) => {
            state.selectedGroup = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(getGroups.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getGroups.fulfilled, (state, action) => {
            state.loading = false;
            state.groups = action.payload;
        });
        builder.addCase(getGroups.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(deleteGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(deleteGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Silinen group'u listeden çıkar
        
        });
        builder.addCase(deleteGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(addGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(addGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Yeni group'u listeye ekle
          
        });
        builder.addCase(addGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(getGroupById.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getGroupById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedGroup = action.payload;
        });
        builder.addCase(getGroupById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(updateGroup.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateGroup.fulfilled, (state, action) => {
            state.loading = false;
            // Güncellenen group'u listede güncelle
       
        });
        builder.addCase(updateGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { clearError, clearSelectedGroup, setSelectedGroup } = groupsSlice.actions;
export default groupsSlice.reducer; 